import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSIActionPlanReportModule4',
    label: 'SSI Action Plan Report - Module 4',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
